import { render } from "./history-item.vue?vue&type=template&id=c6f3fa7a"
import script from "./history-item.vue?vue&type=script&lang=js"
export * from "./history-item.vue?vue&type=script&lang=js"

import "./history-item.vue?vue&type=style&index=0&id=c6f3fa7a&lang=css"

import exportComponent from "C:\\Users\\tnism\\Documents\\Projects\\MiniApp\\miniapp_wing\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__